var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"line"},[_c('ul',{class:{
        'text-right':_vm.line.length == 5,
        'text-center':_vm.line.length < 5
        }},_vm._l((_vm.line),function(item,i){return _c('li',{key:i,on:{"click":function($event){_vm.selectIndex = i}}},[_c('a',{attrs:{"target":"_blank","href":item}},[(_vm.selectIndex == i)?_c('img',{staticClass:"line2",attrs:{"src":require("../assets/images/line7.png")}}):_c('img',{staticClass:"line1",attrs:{"src":require("../assets/images/line5.png")}}),_vm._v(" "),_c('span',[_vm._v("游戏入口-"+_vm._s(_vm.NUm[i]))])])])}))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-619a9f48","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/a.header.line.vue
// module id = 6eEV
// module chunks = 0